function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { forwardRef, useBreakpointValue, IconButton, useScrollYPosition } from '@tempo/core';
import { ArrowBottomIcon } from '@tempo/icons';
import { useLandingPageScales } from './LandingPage';
export const LandingGoToButton = forwardRef((_param, ref)=>{
    var { yBreakpoint: yBreakpointProp = {
        base: 900,
        sm: 700,
        md: 800,
        lg: 1000
    } } = _param, props = _object_without_properties(_param, [
        "yBreakpoint"
    ]);
    const size = {
        base: '64px',
        md: '96px'
    };
    const { containerGutters } = useLandingPageScales();
    const scrollPosition = useScrollYPosition();
    const yBreakpoint = useBreakpointValue(yBreakpointProp) || 0;
    const hasScrolled = scrollPosition > yBreakpoint;
    const buttonBgProps = {
        bg: hasScrolled ? 'background.accent.onContent.tertiary.disabled' : 'background.neutral.tertiary.default',
        _hover: {
            bg: 'background.neutral.tertiary.hovered'
        },
        _active: {
            bg: 'background.neutral.tertiary.pressed'
        }
    };
    const handleClick = useCallback(()=>{
        if (typeof window !== 'undefined') {
            if (hasScrolled) {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            } else {
                window.scrollTo({
                    top: yBreakpoint + 5,
                    behavior: 'smooth'
                });
            }
        }
    }, [
        hasScrolled,
        yBreakpoint
    ]);
    return /*#__PURE__*/ _jsx(IconButton, _object_spread_props(_object_spread(_object_spread_props(_object_spread({
        ref: ref,
        icon: /*#__PURE__*/ _jsx(ArrowBottomIcon, {
            transform: hasScrolled ? 'rotate(-180deg)' : undefined,
            color: "icon.neutral.secondary.default",
            transition: "transform 0.2s",
            transformOrigin: 'center',
            boxSize: {
                base: 5,
                md: 7
            }
        }),
        position: "fixed",
        bottom: {
            base: '10vh',
            md: '20vh'
        }
    }, buttonBgProps), {
        right: containerGutters,
        h: size,
        w: size
    }), props), {
        "aria-label": "go-to-content",
        zIndex: 2,
        onClick: (e)=>{
            handleClick();
            if (props.onClick) {
                props.onClick(e);
            }
        }
    }));
});

//# sourceMappingURL=LandingGoToButton.js.map